<script>
import BRow from "@/components/global_components/BRow";
export default {
  model: {
    prop: 'filter'
  },
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  methods: {
    emitInput(key) {
      return event => this.$emit('input', { ...this.filter, [key]: event });
    }
  },
  render(createElement) {
    const self = this;
    this.$slots.default?.forEach(slot => {
      const modelEvent =
        slot.componentOptions?.Ctor.options.model?.event || 'input';
      const modelProp =
        slot.componentOptions?.Ctor.options.model?.prop || 'value';
      const key = slot.data.attrs ? slot.data.attrs.searchKey : null;

      if (!slot.componentOptions.propsData)
        slot.componentOptions.propsData = {};
      if (!slot.componentOptions.listeners)
        slot.componentOptions.listeners = {};

      slot.componentOptions.propsData[modelProp] = self.filter[key];
      slot.componentOptions.listeners[modelEvent] = self.emitInput(key);
    });
    return createElement(BRow, this.$slots.default);
  }
};
</script>
